module.exports = __webpack_public_path__ + "static/media/vendido.dd9f3c13.png";